module.exports = __webpack_public_path__ + "static/media/shopping-cart-add.8e2e6020.png";